"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CHARITY = exports.DISABLED_FAMILY = exports.CONTRIBUTIONS_TO_FAMILY = exports.NOT_DEDUCTED_ALIMONY = exports.CHILD_EDUCTION = exports.DAYCARE_BABYSITTER = exports.OTHER_TRANSPORTATION = exports.VEHICLE_MAINTENANCE = exports.GASOLINE = exports.VEHICLE_INSURANCE = exports.OTHER_INSURANCE = exports.RETIREMENT_LOANS = exports.LIFE_INSURANCE = exports.INSTALLMENT_LEASE = exports.TAX_PAYMENTS = exports.NOT_DEDUCTED_HEALTH_INSURANCE = exports.CONTACTS = exports.GLASSES = exports.VISION_EXPENSES = exports.DENTAL_PRESCRIPTIONS = exports.DENTAL_EXPENSES = exports.MEDICAL_PRESCRIPTIONS = exports.MEDICAL_EXPENSES = exports.RECREATION = exports.CLOTHING = exports.CLEANING_LAUNDRY = exports.HAIR_CUTS = exports.PERSONAL_CARE = exports.GROCERIES = exports.OTHER_UTILITIES = exports.CELL_PHONE = exports.CABLE_PHONE_INTERNET = exports.WATER_SEWER_TRASH = exports.HEAT = exports.ELECTRIC = exports.HOA_CONDO_FEES = exports.UPKEEP_REPAIRS = exports.PROPERTY_INSURANCE = exports.PROPERTY_TAXES = exports.MORTGAGE_RENT = void 0;
var MORTGAGE_RENT = 'mortgage_rent';
exports.MORTGAGE_RENT = MORTGAGE_RENT;
var PROPERTY_TAXES = 'property_taxes';
exports.PROPERTY_TAXES = PROPERTY_TAXES;
var PROPERTY_INSURANCE = 'property_insurance';
exports.PROPERTY_INSURANCE = PROPERTY_INSURANCE;
var UPKEEP_REPAIRS = 'upkeep_repairs';
exports.UPKEEP_REPAIRS = UPKEEP_REPAIRS;
var HOA_CONDO_FEES = 'hoa_condo_fees';
exports.HOA_CONDO_FEES = HOA_CONDO_FEES;
var ELECTRIC = 'electric';
exports.ELECTRIC = ELECTRIC;
var HEAT = 'heat';
exports.HEAT = HEAT;
var WATER_SEWER_TRASH = 'water_sewer_trash';
exports.WATER_SEWER_TRASH = WATER_SEWER_TRASH;
var CABLE_PHONE_INTERNET = 'cable_phone_internet';
exports.CABLE_PHONE_INTERNET = CABLE_PHONE_INTERNET;
var CELL_PHONE = 'cell_phone';
exports.CELL_PHONE = CELL_PHONE;
var OTHER_UTILITIES = 'other_utilities';
exports.OTHER_UTILITIES = OTHER_UTILITIES;
var GROCERIES = 'groceries';
exports.GROCERIES = GROCERIES;
var PERSONAL_CARE = 'personal_care';
exports.PERSONAL_CARE = PERSONAL_CARE;
var HAIR_CUTS = 'hair_cuts';
exports.HAIR_CUTS = HAIR_CUTS;
var CLEANING_LAUNDRY = 'cleaning_laundry';
exports.CLEANING_LAUNDRY = CLEANING_LAUNDRY;
var CLOTHING = 'clothing';
exports.CLOTHING = CLOTHING;
var RECREATION = 'recreation';
exports.RECREATION = RECREATION;
var MEDICAL_EXPENSES = 'medical_expenses';
exports.MEDICAL_EXPENSES = MEDICAL_EXPENSES;
var MEDICAL_PRESCRIPTIONS = 'medical_prescriptions';
exports.MEDICAL_PRESCRIPTIONS = MEDICAL_PRESCRIPTIONS;
var DENTAL_EXPENSES = 'dental_expenses';
exports.DENTAL_EXPENSES = DENTAL_EXPENSES;
var DENTAL_PRESCRIPTIONS = 'dental_prescriptions';
exports.DENTAL_PRESCRIPTIONS = DENTAL_PRESCRIPTIONS;
var VISION_EXPENSES = 'vision_expenses';
exports.VISION_EXPENSES = VISION_EXPENSES;
var GLASSES = 'glasses';
exports.GLASSES = GLASSES;
var CONTACTS = 'contacts';
exports.CONTACTS = CONTACTS;
var NOT_DEDUCTED_HEALTH_INSURANCE = 'not_deducted_health_insurance';
exports.NOT_DEDUCTED_HEALTH_INSURANCE = NOT_DEDUCTED_HEALTH_INSURANCE;
var TAX_PAYMENTS = 'tax_payments';
exports.TAX_PAYMENTS = TAX_PAYMENTS;
var INSTALLMENT_LEASE = 'installment_lease';
exports.INSTALLMENT_LEASE = INSTALLMENT_LEASE;
var LIFE_INSURANCE = 'life_insurance';
exports.LIFE_INSURANCE = LIFE_INSURANCE;
var RETIREMENT_LOANS = 'retirement_loans';
exports.RETIREMENT_LOANS = RETIREMENT_LOANS;
var OTHER_INSURANCE = 'other_insurance';
exports.OTHER_INSURANCE = OTHER_INSURANCE;
var VEHICLE_INSURANCE = 'vehicle_insurance';
exports.VEHICLE_INSURANCE = VEHICLE_INSURANCE;
var GASOLINE = 'gasoline';
exports.GASOLINE = GASOLINE;
var VEHICLE_MAINTENANCE = 'vehicle_maintenance';
exports.VEHICLE_MAINTENANCE = VEHICLE_MAINTENANCE;
var OTHER_TRANSPORTATION = 'other_transportation';
exports.OTHER_TRANSPORTATION = OTHER_TRANSPORTATION;
var DAYCARE_BABYSITTER = 'daycare_babysitter';
exports.DAYCARE_BABYSITTER = DAYCARE_BABYSITTER;
var CHILD_EDUCTION = 'child_education';
exports.CHILD_EDUCTION = CHILD_EDUCTION;
var NOT_DEDUCTED_ALIMONY = 'not_deducted_alimony';
exports.NOT_DEDUCTED_ALIMONY = NOT_DEDUCTED_ALIMONY;
var CONTRIBUTIONS_TO_FAMILY = 'contributions_to_family';
exports.CONTRIBUTIONS_TO_FAMILY = CONTRIBUTIONS_TO_FAMILY;
var DISABLED_FAMILY = 'disabled_family';
exports.DISABLED_FAMILY = DISABLED_FAMILY;
var CHARITY = 'charity';
exports.CHARITY = CHARITY;